import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";

const COMPANY_NAME = "NetBasis International";

const title = "Analyses de marché";
const h1Text = "Des analyses de marché approfondies pour une entrée réussie sur le marché de la région DACH. En tant que votre interface opérationnelle, nous vous fournissons une business intelligence précise et des services d'étude de marché pour comprendre exactement les besoins du marché, sa taille et la concurrence établie en Allemagne, en Autriche et en Suisse.";
const heroImage = "https://net-basis.net/Bilder/market-analysis-business-intelligence-dach-market-entry.webp";
const heroAlt = "Un homme d'affaires analyse des données de marché numériques pour guider l'entrée sur le marché.";
const heroClaimLine1 = "Comprendre les marchés !";
const heroClaimLine2 = "Décider en toute sécurité !";
const benefitsTitle = "Comment vous profitez de notre expertise en __analyses de marché__ :";
const p1Text = "NetBasis International propose à ses clients un ensemble complet de services d'étude de marché, en tant que composante essentielle de leur stratégie commerciale et facteur clé décisif pour se démarquer de la concurrence. Nous fournissons aux fabricants étrangers de TIC toutes les informations pertinentes nécessaires pour prendre des décisions commerciales éclairées et sûres sur le terrain.";
const p1Parts = p1Text.split(COMPANY_NAME);
const bottomClaim = "NetBasis International - drive to excellence with excellent drivers !";

const benefits = [
  "Analyse des tendances du marché, des activités du marché et des thématiques sectorielles",
  "Évaluation de la taille du marché, des caractéristiques spécifiques du marché et des tendances",
  "Rapports de fond sur les concurrents étrangers et leur déploiement local, leurs donneurs d'ordre et leurs partenaires ou clients",
  "Définition stratégique de stratégies de marketing et de gestion sur mesure",
  "Définitions précises du marché segmentées par groupes de partenaires et de clients potentiels",
  "Définition des fournisseurs, des clients et des partenaires, négociants ou distributeurs",
  "Examen et clarification de l'ensemble des procédures réglementaires et des directives locales",
];

export default function AnalysesDeMarcheFrPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Analyses de Marché | NetBasis International"
        description="Données fiables et perspectives précises sur la région DACH comme base solide pour vos décisions d’expansion stratégique."
        ogUrl="https://net-basis.net/fr/services/developpement-commercial/analyses-de-marche"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        {/* Hero image */}
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src={heroImage}
                alt={heroAlt}
                title={title}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

              <div className="absolute inset-0 z-20 flex items-start justify-end pt-[6%] md:pt-[4%] lg:pt-[3%] pr-[8%] md:pr-[4%] lg:pr-[4%] pointer-events-none">
                <p
                  className="text-[1.625rem] md:text-4xl lg:text-5xl font-normal text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] text-right marktanalysen-hero-text-slide ma-hero-lh-15"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  <span className="block">{heroClaimLine1}</span>
                  <span className="block">{heroClaimLine2}</span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {title}
            </h2>

            <h1 className="font-semibold text-foreground-950 leading-relaxed text-sm md:text-base mb-4">
              {h1Text}
            </h1>

            <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
              <p>
                {p1Parts.map((part, i) => (
                  <span key={i}>
                    {part}
                    {i < p1Parts.length - 1 && (
                      <strong className="text-primary-600">{COMPANY_NAME}</strong>
                    )}
                  </span>
                ))}
              </p>
            </div>

            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mt-8 md:mt-10 mb-5 md:mb-7">
              {benefitsTitle.split("__").map((part, i) =>
                i % 2 === 1 ? <em key={i}>{part}</em> : part
              )}
            </h2>

            <div className="space-y-1.5 md:space-y-2 text-foreground-950 leading-relaxed text-sm md:text-base">
              {benefits.map((benefit, idx) => (
                <div key={idx} className="flex items-start gap-2 md:gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-600 text-base md:text-lg"></i>
                  </div>
                  <p>{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bottom claim */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {bottomClaim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}